/**
 * created by lei lei
 * 微博情感分页面
 *
 */
import React, {Component} from 'react';
import {Modal, Button, Tabs, Row, Col} from 'antd';
import PropTypes from 'prop-types';
import Title from "../components/title/Title";
import BrokenLineAnalysis from "../components/analysis/BrokenLineAnalysis";
import CustomTable, {TitleIcon} from "../components/customTable/CustomTable";
import {Scrollbars} from "react-custom-scrollbars";
import * as utils from "../../utils";

const {TabPane} = Tabs;

export default class EmotionalAnalysis extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            statusKey: '1',
            option1: { //当前展示的数据源
                xData: [/*'1', '2', '3', '1', '2', '3', '1', '2', '3', '1', '2', '3'*/],//折线图x轴数据
                colorList: ['#FFBF00', '#00A854', '#0E77D1'],//折线图颜色自定义
                yData: [{ //折线图Y轴数据
                    name: '正面',
                    data: [/*1, 2, 3, 4, 5, 6, 6, 7, 8, 9, 9, 9,*/]
                }, {
                    name: '负面',
                    data: [/*1, 2, 3, 4, 6, 67, 6, 7, 77, 77, 9, 9,*/]
                }, {
                    name: '中性',
                    data: [/*1, 2, 3, 4, 5, 6, 44, 55, 8, 9, 88, 99,*/]
                }]

            },
            option2: {
                data: [
                    {value: 335, name: '正面'},//饼状图数据
                    {value: 310, name: '负面'},
                    {value: 234, name: '中性'},
                ],
                colorList: ['#FFBF00', '#00A854', '#0E77D1'],//饼状图颜色
            },
            option3: { //当前展示的数据源
                xData: [/*'1', '2', '3', '1', '2', '3', '1', '2', '3', '1', '2', '3'*/],//折线图x轴数据
                colorList: ['#FFBF00', '#00A854', '#0E77D1'],//折线图颜色自定义
                yData: [{ //折线图Y轴数据
                    name: '正面',
                    data: [/*1, 2, 3, 4, 5, 6, 6, 7, 8, 9, 9, 9,*/]
                }, {
                    name: '负面',
                    data: [/*1, 2, 3, 4, 6, 67, 6, 7, 77, 77, 9, 9,*/]
                }, {
                    name: '中性',
                    data: [/*1, 2, 3, 4, 5, 6, 44, 55, 8, 9, 88, 99,*/]
                }]

            }
            , dataSource1: [],
            dataSource2: [],
            dataSource3: [],
            tableData: {},
            dataSource: [],
            publishUrl:'',
            page:1,
            size:10,

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    showModal(data) {
        this.BrokenLineAnalysis1 && this.BrokenLineAnalysis1.hideTable();
        this.BrokenLineAnalysis2 && this.BrokenLineAnalysis2.hideTable();
        this.BrokenLineAnalysis3 && this.BrokenLineAnalysis3.hideTable();
        this.state.statusKey = '1';
        //console.log(data)
        this.state.option1.xData = [];
        this.state.option1.yData[0].data = [];
        this.state.option1.yData[1].data = [];
        this.state.option1.yData[2].data = [];
        this.state.dataSource1 = [];
        this.state.option3.xData = [];
        this.state.option3.yData[0].data = [];
        this.state.option3.yData[1].data = [];
        this.state.option3.yData[2].data = [];
        this.state.dataSource3 = [];
        this.state.option2.data = [];
        this.state.dataSource2 = [];
        this.state.tableData = {};
        this.state.dataSource = [];
        this.state. publishUrl='';
        if (data) {
            let listStatics1 = data.comment_time_line;
            listStatics1.forEach(item => {
                this.state.option1.xData.push(item.data);
                this.state.option1.yData[0].data.push(item.pos.value);
                this.state.option1.yData[1].data.push(item.neg.value);
                this.state.option1.yData[2].data.push(item.neu.value);
                this.state.dataSource1.push({
                    date: item.data,
                    pos: item.pos.value,
                    neu: item.neg.value,
                    neg: item.neu.value,
                })
                this.state.option3.xData.push(item.data);//百分比折线图
                this.state.option3.yData[0].data.push(item.pos.percentage);
                this.state.option3.yData[1].data.push(item.neg.percentage);
                this.state.option3.yData[2].data.push(item.neu.percentage);
                this.state.dataSource3.push({
                    date: item.data,
                    pos: item.pos.percentage ? item.pos.percentage + '%' : 0,
                    neu: item.neg.percentage ? item.neg.percentage + '%' : 0,
                    neg: item.neu.percentage ? item.neu.percentage + '%' : 0,
                })
            });
            let sentiment_type = data.sentiment_type;//饼状图数据
            this.state.option2.data = sentiment_type;
            this.state.dataSource2 = sentiment_type;
            //表格数据格式化
            this.state.tableData = data.opinion;
            //this.state.dataSource = [];
            this.state. publishUrl=data.publishUrl;
            this.setState({
                visible: true,
            });
        }

    };

    render() {
        let titleKeyList1 = [
            {
                key: 'date',
                titleName: '时间',
                width: '25%',
                align: 'center',
                ellipsis: true,
            },
            {
                key: 'pos',
                titleName: '正面',
                width: '25%',
                align: 'center',

            },
            {
                key: 'neu',
                titleName: '负面',
                width: '25%',
                align: 'center',

            }, {
                key: 'neg',
                titleName: '中性',
                width: '25%',
                align: 'center',

            },];
        let titleKeyList2 = [
            {
                key: 'name',
                titleName: '正负面',
                width: '25%',
                align: 'center',
                ellipsis: true,
            },
            {
                key: 'value',
                titleName: '数据量',
                width: '25%',
                align: 'center',

            },
        ];
        let titleKeyList3 = [
            {
                key: 'date',
                titleName: '时间',
                width: '25%',
                align: 'center',
                ellipsis: true,
            },
            {
                key: 'pos',
                titleName: '正面',
                width: '25%',
                align: 'center',

            },
            {
                key: 'neu',
                titleName: '负面',
                width: '25%',
                align: 'center',

            }, {
                key: 'neg',
                titleName: '中性',
                width: '25%',
                align: 'center',

            },];

        let titleKeyList =
            [{
                key: 'key',
                titleName: '序号',
                width: 100,
                align: 'center',
                ellipsis: true,
            },
                {
                    key: 'age',
                    titleName: '账号头像',
                    width: 200,
                    align: 'center',
                    render: (text, record, index) => {
                        return (<div>
                                <img src={record.headImg} style={{height:20,width:20,borderRadius:'50%'}} alt=""/>
                            </div>

                        )
                    }
                },
                {
                    key: 'name',
                    titleName: '账号名称',
                    width: '20%', align: 'center',
                }, {
                key: 'content',
                titleName: '评论信息',
                width: 300,
                align: 'center',
                render: (text, record, index) => {
                    return (<div title={record.content} onClick={()=>{
                            if(this.state.publishUrl){
                                window.open(this.state.publishUrl);
                            }
                        }} style={{width:290,overflow: 'hidden',cursor:'pointer',
                            textOverflow: 'ellipsis',color:'#0050B3',
                            whiteSpace: 'nowrap' }}>
                            {record.content}
                        </div>

                    )
                }
            }, {
                key: 'opinion_word',
                titleName: '评论词',
                width: '20%', align: 'center',
            },/* {
                key: 'title',
                titleName: '出现次数',
                width: '20%', align: 'center',
            },*/
                {
                    key: 'address',
                    titleName: '评论时间',
                    width: '20%', align: 'center',
                    render: (text, record, index) => {
                        return (<div>
                                {utils.formatDate(record.commentTime)}
                            </div>

                        )
                    }
                },
            ];


        return (
            <div>
                <Modal
                    title={null}
                    footer={null}
                    visible={this.state.visible}
                    onOk={() => {
                    }}
                    width={1300}
                    onCancel={() => {
                        this.setState({visible: false})
                    }}
                >
                    <div style={{height: 740}}>
                        <Tabs defaultActiveKey={this.state.statusKey} activeKey={this.state.statusKey}
                              onChange={(key) => {
                                  this.state.statusKey = key;
                                  if(key!=='1'){
                                      this.state.page=1;
                                      this.state.size=10;
                                      this.state.dataSource=this.state.tableData[key]
                                  }
                                  this.setState({})
                              }} tabBarGutter={0}>
                            <TabPane tab={"正负面趋势分析"} key={'1'}>
                            </TabPane>
                            <TabPane tab={"正面评论汇总"} key={'pos'}>
                            </TabPane>
                            <TabPane tab={"负面评论汇总"} key={'neg'}>
                            </TabPane>
                            <TabPane tab={"中性评论汇总"} key={'neu'}>
                            </TabPane>

                        </Tabs>
                        {this.state.statusKey === '1' ? <div>
                                <div>
                                    <Row>
                                        <Col span={14}>
                                            <Title title={'正负面趋势（人数）'}/>
                                            <div key={1}>
                                                <BrokenLineAnalysis
                                                    dataSource={this.state.dataSource1}
                                                    ref={(BrokenLineAnalysis1) => {
                                                        this.BrokenLineAnalysis1 = BrokenLineAnalysis1
                                                    }}
                                                    titleKeyList={titleKeyList1}
                                                    option={this.state.option1}
                                                    height={300}
                                                    type={'line1'}
                                                />
                                            </div>

                                        </Col>
                                        <Col span={10}>
                                            <Title title={'正负面属性'}/>
                                            <BrokenLineAnalysis
                                                dataSource={this.state.dataSource2}
                                                ref={(BrokenLineAnalysis2) => {
                                                    this.BrokenLineAnalysis2 = BrokenLineAnalysis2
                                                }}
                                                height={300}
                                                titleKeyList={titleKeyList2}
                                                option={this.state.option2}
                                                type={'pie'}
                                            />
                                        </Col>
                                    </Row>
                                    <Title title={'正负面趋势占比'}/>
                                    <div key={2}>
                                        <BrokenLineAnalysis
                                            dataSource={this.state.dataSource3}
                                            ref={(BrokenLineAnalysis3) => {
                                                this.BrokenLineAnalysis3 = BrokenLineAnalysis3
                                            }}
                                            titleKeyList={titleKeyList3}
                                            option={this.state.option3}
                                            height={300}
                                            type={'line2'}
                                        />
                                    </div>


                                </div>
                            </div> :
                            <div style={{height: 700}}>
                                <Scrollbars>
                                    <CustomTable
                                        dataSource={this.state.dataSource}
                                        titleKeyList={titleKeyList}
                                        //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                                        pagination={{
                                            current: this.state.page,
                                            pageSize: this.state.size,
                                            showQuickJumper: true,
                                            total: this.state.dataSource.length,
                                            onChange: (page, pageSize) => {
                                                this.onChange(page, pageSize)
                                            },
                                            onShowSizeChange: (page, pageSize) => {
                                                this.onChange(page, pageSize)
                                            },
                                            style: {marginRight: '20px'},
                                            showTotal: total => `共 ${total} 条数据`,
                                            showSizeChanger: true,
                                            pageSizeOptions: ['10', '20', '30', '40'],
                                            position: 'bottom'//这个版本目前只支持上下，不支持bottomLeft
                                        }}
                                        onRow={(record, index) => {
                                            return {
                                                onClick: event => {
                                                    // console.log('onclickItem', record, index)
                                                }, // 点击行
                                                onDoubleClick: event => {
                                                },
                                                onContextMenu: event => {
                                                },
                                                onMouseEnter: event => {
                                                }, // 鼠标移入行
                                                onMouseLeave: event => {
                                                },
                                            };
                                        }}
                                        locale={{emptyText: '暂无数据'}}

                                    />
                                </Scrollbars>
                            </div>
                        }
                    </div>
                </Modal>
            </div>
        )
    }

    onChange(page, pageSize){
        this.setState({
            page:page,
            size:pageSize
        })
    }

}